"use strict";exports.clamp=function(t,r,a){if(t>a)throw new Error("The min of ".concat(t," is greater than the max of ").concat(a));return Math.max(t,Math.min(r,a))};
//# sourceMappingURL=clamp.cjs.map
